/**
 * Lien WhatsApp (wa.me) d'un numéro : indicatif + numéro, chiffres uniquement.
 * Accepte « +229 0197... » dans phone seul, ou phone + phone_code séparés.
 */
export function whatsappUrl(phone, phoneCode = '') {
    if (!phone) return null
    const raw = String(phone).trim().startsWith('+') ? String(phone) : `${phoneCode || ''}${phone}`
    const digits = raw.replace(/\D/g, '')
    return digits ? `https://wa.me/${digits}` : null
}
